import { getSearchParams, GtmEvents, useGtmLogger, useSuccessPageUrl } from '@wix/package-picker-shared';
import { useCurrentModule } from '../../ModuleProvider';
export const useSubmitSuccess = _ref => {
  let {
    eventAggregator
  } = _ref;
  const {
    siteGuid,
    domainName,
    referralAdditionalInfo
  } = getSearchParams();
  const module = useCurrentModule();
  const {
    report
  } = useGtmLogger();
  const {
    getSuccessPageUrl
  } = useSuccessPageUrl({
    siteGuid,
    domainName,
    referralAdditionalInfo
  });

  // TODO: Test that it works
  const biHandler = urlType => {
    const {
      onGoToSepaSuccessPage,
      onGoToBoletoSuccessPage,
      onGoToSuccessPage
    } = module.internals.bi;
    switch (urlType) {
      case 'sepa':
        return onGoToSepaSuccessPage;
      case 'boleto':
        return onGoToBoletoSuccessPage;
    }
    return onGoToSuccessPage;
  };
  const handleSubmitSuccess = _ref2 => {
    let {
      invoiceId,
      invoiceStatus
    } = _ref2;
    report(GtmEvents.SUCCESS);
    const url = getSuccessPageUrl({
      invoiceId,
      invoiceStatus,
      eventAggregator,
      biHandler
    });
    if (url) {
      window.location.assign(url);
    }
  };
  return {
    handleSubmitSuccess
  };
};
//# sourceMappingURL=useSubmitSuccess.js.map